import { render, staticRenderFns } from "./tomador.vue?vue&type=template&id=6056f22d"
import script from "./tomador.vue?vue&type=script&lang=js"
export * from "./tomador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports